import type { FlowTemplate, Flow } from '../types';
import { api, ApiError } from './apiClient';
import { newFlow } from '../lib/factories';
import { uid } from '../lib/utils';

export const templatesService = {
  async list(): Promise<FlowTemplate[]> {
    const res = await api.get<{ templates: FlowTemplate[] }>('/templates');
    return res.templates;
  },

  async get(id: string): Promise<FlowTemplate | undefined> {
    try {
      const res = await api.get<{ template: FlowTemplate }>(`/templates/${encodeURIComponent(id)}`);
      return res.template;
    } catch (err) {
      if (err instanceof ApiError && err.status === 404) return undefined;
      throw err;
    }
  },

  // Cria uma cópia editável (Flow) a partir de um template, com ids de nó únicos.
  // Continua client-side: a persistência acontece via flowsService.save().
  async instantiate(templateId: string): Promise<Flow | undefined> {
    const tpl = await this.get(templateId);
    if (!tpl) return undefined;

    const idMap = new Map<string, string>();
    tpl.nodes.forEach((n) => idMap.set(n.id, uid('node')));

    const flow = newFlow({
      name: `${tpl.name} (cópia)`,
      description: tpl.description,
      oversightMode: tpl.oversightMode,
      nodes: tpl.nodes.map((n) => ({
        ...structuredClone(n),
        id: idMap.get(n.id)!,
      })),
      edges: tpl.edges.map((e) => ({
        ...structuredClone(e),
        id: uid('edge'),
        source: idMap.get(e.source)!,
        target: idMap.get(e.target)!,
      })),
    });
    return flow;
  },
};
